<template>
  <div class="top-bar">
    <div class="bar-main">
      <img src="../../assets/better.png" class="icon" @click="goHome()" />
      <span class="bar-item-active">校招</span>
      <span class="bar-item">职位</span>
      <span class="bar-item">课程中心</span>
      <span class="bar-item">关于我们</span>
      <span class="bar-item">企业合作</span>
      <div class="mini-app">官方小程序</div>
      <div class="enterprises">企业入口</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goHome(){
      this.$router.back()
    }
  },
};
</script>

<style lang="less" scoped>
.top-bar {
  position: fixed;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 68px;
  background-color: #fff;
  .bar-main {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 60vw;
    min-width: 1000px;
    // background-color: #ccc;
    .icon {
      margin-left: 7vw;
      width: 50px;
      height: 50px;
    }
    .bar-item {
      margin-left: 3vw;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.6);
    }
    .bar-item-active {
      margin-left: 3vw;
      font-size: 18px;
      color: #f92b29;
    }
    .mini-app {
      margin-left: 40px;
      width: 120px;
      height: 40px;
      background-color: #fff;
      border: solid 1px #f92b29;
      border-radius: 40px;
      text-align: center;
      line-height: 40px;
      color: #f92b29;
      font-size: 14px;
    }
    .enterprises {
      margin-left: 10px;
      width: 120px;
      height: 40px;
      background-color: #fff;
      border: solid 1px #f92b29;
      border-radius: 40px;
      text-align: center;
      line-height: 40px;
      color: #f92b29;
      font-size: 14px;
    }
  }
}
</style>
